const buildPaymentRequest = async (amount, stripe) => {
  const pr = stripe.paymentRequest({
    country: 'GB',
    currency: 'gbp',
    total: {
      label: "A Child To Learn donation",
      amount: amount,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  })

  return !!(await pr.canMakePayment()) ? pr : false
}

const setPaymentListener = ({
  paymentRequest,
  clientSecret,
  onPaymentSuccess,
  onPaymentFail,
  stripe,
}) => {
  paymentRequest.on('paymentmethod', async (ev) => {
    // Confirm the PaymentIntent without handling potential next actions (yet).
    const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
      clientSecret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    )

    if (confirmError) {
      // Report to the browser that the payment failed, prompting it to
      // re-show the payment interface, or show an error message and close
      // the payment interface.
      // ev.complete()
      onPaymentFail()
      ev.complete('success')
    } else {
      // Report to the browser that the confirmation was successful, prompting
      // it to close the browser payment method collection interface.
      ev.complete('success')
      // Check if the PaymentIntent requires any actions and if so let Stripe.js
      // handle the flow. If using an API version older than "2019-02-11" instead
      // instead check for: `paymentIntent.status === "requires_source_action"`.
      if (paymentIntent.status === 'requires_action') {
        // Let Stripe.js handle the rest of the payment flow.
        const { error } = await stripe.confirmCardPayment(clientSecret)
        if (error) {
          onPaymentFail()
        } else {
          onPaymentSuccess()
        }
      } else {
        onPaymentSuccess()
      }
    }
  })
}

const getIntent = (pr, amount, onSuccess, onFail) => {
  // Check the availability of the Payment Request API.
  pr.canMakePayment().then(async (available) => {
    if (available) {
      try {
        const intent = await axios.post('/api/donations/intent', {
          amount: amount,
        })
        if (intent.status === 200) {
          onSuccess(intent)
        } else {
          onFail()
        }
      } catch {
        onFail()
      }
    }
  })
}

export { setPaymentListener, buildPaymentRequest, getIntent }
